/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import CardProfile from '@dtvgo/card-profile';
import InteractiveElement from '@dtvgo/interactive-element';

/* Utils */
import withInteractiveFocusable from '../../hocs/withInteractiveFocusable.hoc';

/* Styles */
import './FocusableCardProfile.scss';

export function FocusableCardProfile({
  className,
  focused,
  name,
  color,
  nameUser,
  onClick,
  onMouseDown,
  onMouseEnter,
  key,
}) {
  return (
    <InteractiveElement
      onMouseDown={onMouseDown}
      onMouseEnter={onMouseEnter}
      className={
      `dtv-html5-c-card-profile ${
        focused ? 'dtv-html5-c-card-profile--focused' : ''
      } ${className}`
    }
      key={key}
    >
      <CardProfile
        name={name}
        color={color}
        nameUser={nameUser}
        onClick={onClick}
        className="dtv-html5-c-card-profile--logo"
      />
    </InteractiveElement>
  );
}

FocusableCardProfile.propTypes = {
  className: PropTypes.string,
  focused: PropTypes.bool,
  name: PropTypes.string,
  color: PropTypes.oneOf(['avatar-bg-1', 'avatar-bg-2', 'avatar-bg-3', 'avatar-bg-4', 'avatar-bg-5']),
  nameUser: PropTypes.bool,
  onClick: PropTypes.func,
  onMouseDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
  key: PropTypes.number,
};

FocusableCardProfile.defaultProps = {
  className: '',
  focused: false,
  name: '',
  color: 'blue',
  nameUser: true,
  onClick: undefined,
  onMouseDown: undefined,
  onMouseEnter: undefined,
  key: 0,
};

export default memo(withInteractiveFocusable()(memo(FocusableCardProfile)));
